const _ = require('underscore/underscore-min');
const Utils = require('core-helpers/utils.js');
const ExceptionService = require('exceptions/exception-service.js');
const PurchaseService = require('purchase/purchase-service.js');

(function(root, doc, undefined) {

    'use strict';

    // Private vars
    const filename = 'premium-header-controller.js';
    const headerPriceWrap = Utils.getById('premium-header-price-wrap');
    const headerPrice = Utils.getById('premium-header-price');
    const headerPriceWrapClass = 'main-header__price--hide';
    const headerPriceStrikeClass = 'main-header__price--strike';
    const headerPriceBigClass = 'main-header__price-impact';

    const onCodeFailure = (error) => {
        ExceptionService.handle('error', {
            filename: filename,
            data: error
        });
    };

    const getTranslation = (key) => {
        return BUSUU_TRANSLATIONS[key] || 'TRS_NOT_FOUND';
    };

    const showHeaderPrice = () => {
        Utils.removeClass(headerPriceWrap, headerPriceWrapClass);
    };

    /**
     * Returns a constructed header string of 'From $x'
     * @param {Object} monthly details of plan
     * @return {String}
     */
    const getHeaderPriceString = (data) => {

        let priceText = getTranslation('FROM_PRICE');
        let priceHTML = '';
        let finalPrice = data.plan.monthlyPrice.humanFormats.symbol;

        // If discounted, display original price and add strike through
        if (data.hasOwnProperty('afterDiscountMonthlyPrice')) {
            finalPrice = data.afterDiscountMonthlyPrice.humanFormats.symbol;
            const originalPrice = data.plan.monthlyPrice.humanFormats.symbol;
            priceHTML = `<span class="${headerPriceStrikeClass}">${originalPrice}</span>`;
        }

        priceHTML += `<span class="${headerPriceBigClass}">${finalPrice}</span>`;

        return priceText.replace('%s', priceHTML);
    };

    /**
     * Inject the correct string into the header div
     * Call showHeaderPrice to fade in div
     * @param {Object} plan data
     */
    const appendHeaderPrice = (data) => {
        const headerPriceString = getHeaderPriceString(data);
        if(headerPriceString) {
            headerPrice.innerHTML = headerPriceString;
            showHeaderPrice();
        }
    };

    /**
     * On API call succes, we want to do 2 things:
     * - Filter the plans to keep the cheapest
     * - Append the correct string to the header
     * @param {Object} API response
     */
    const onSuccess = (data) => {
        const cheapestPlan = PurchaseService.getCheapestPlan(data.plans);
        if(cheapestPlan){
            appendHeaderPrice(cheapestPlan);
        }else {
            onCodeFailure({
                reason: 'Can\'t find cheapest plan',
                plans: data
            });
        }
    };

    // Get available plans
    const fetchPlans = () => {
        PurchaseService.getPlans().then(onSuccess).done();
    };

    const init = () => {

        // Get all the plans if element is found on page
        if (headerPriceWrap && headerPrice) {
            fetchPlans();
        }
    };

    init();

})(window, document);
